import { createRoot } from "react-dom/client";

import { App } from "@/app";

const root = document.querySelector("#root")!;

const createdRoot = createRoot(root);

createdRoot.render(<App />);
